<template>
  <div class="strategy-manager page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <vs-button
          color="primary"
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:spiderArticle:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('wx:spiderArticle:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              策略名称
            </vs-th>
            <vs-th>
              文章类型
            </vs-th>
            <vs-th>
              内容
            </vs-th>

            <vs-th>
              发布时间
            </vs-th>
            <vs-th>
              推送状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.strategyName}}
              </vs-td>
              <vs-td>
                {{getContentType(tr)}}
              </vs-td>
              <vs-td
                style="max-width: 500px"
              >
                <div
                  v-if="isImageContent(tr)"
                  class="content"
                >
                  <img :src="tr.content" alt="图片预览">
                </div>
                <div
                  v-else-if="isVideoContent(tr)"
                  class="content video-preview"
                >
                  <video
                    :src="getVideoPreview(tr).url"
                    controls
                    preload="metadata"
                  ></video>
                  <div
                    class="ql-container rap-normal"
                    v-html="getVideoPreview(tr).text"
                  ></div>
                </div>
                <div
                  v-else-if="isFileContent(tr)"
                  class="content file-preview"
                >
                  <a
                    v-if="getFilePreview(tr).url"
                    :href="getFilePreview(tr).url"
                    class="theme-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{getFilePreview(tr).name}}</a>
                  <div
                    class="ql-container rap-normal"
                    v-html="getFilePreview(tr).text"
                  ></div>
                </div>
                <div
                  v-else
                  class="content ql-container rap-normal"
                  v-html="tr.content"
                ></div>
              </vs-td>

              <vs-td>
                {{parseTime(tr.publishTime)}}
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{getStatus(tr)}}</span>
              </vs-td>
              <vs-td>
                <el-button
                  v-if="isAuth('wx:spiderArticle:update')"
                  type="text"
                  class="theme-color"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:spiderArticle:delete')"
                  type="text"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-statrgy-article-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addSuccess"
    ></add-statrgy-article-dialog>
    <edit-statrgy-article-dialog
      :form-data="formData"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-statrgy-article-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editStatrgyArticleDialog from '@/components/wx/strategyArticle/editStatrgyArticleDialog'
import addStatrgyArticleDialog from "@/components/wx/strategyArticle/addStatrgyArticleDialog";
import queryHeader from "@/components/wx/strategyArticle/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {
  deleteArticle,
  getStrategyArticleContentTypeName,
  parseStrategyArticleContent
} from "@/api/wx/strategyActicle";
export default {
  name: "index",
  components: {
    addStatrgyArticleDialog,
    editStatrgyArticleDialog,
    queryHeader,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      typeList: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      formData: {},
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/spiderArticle/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
      }
      let header = this.$refs.header;
      if(header.type){
        this.params.strategyId = header.type;
      }
      if(header.status !== ''){
        this.params.pushStatus = header.status;
      }
      if(header.textType){
        this.params.contentType = header.textType;
      }
      if(header.pickerTime && header.pickerTime.length){
        this.params.startTime = header.pickerTime[0];
        this.params.endTime = header.pickerTime[1];
      }
      return true;
    },
    getContentType(row) {
      return getStrategyArticleContentTypeName(row.contentType);
    },
    isImageContent(row) {
      return row.contentType === 2;
    },
    isVideoContent(row) {
      return row.contentType === 4 || row.contentType === 5;
    },
    getVideoPreview(row) {
      const content = parseStrategyArticleContent(row.contentType, row.content);
      return row.contentType === 4
        ? { url: content.contentVideo, text: '' }
        : { url: content.contentVideoTextUrl, text: content.contentVideoText };
    },
    isFileContent(row) {
      return row.contentType === 6;
    },
    getFilePreview(row) {
      const content = parseStrategyArticleContent(row.contentType, row.content);
      try {
        const url = new URL(content.contentFileUrl);
        const valid = ['http:', 'https:'].includes(url.protocol) && url.hostname;
        const encodedName = valid ? url.pathname.split('/').pop() : '';
        let name = encodedName || '查看文件';
        try {
          name = decodeURIComponent(name);
        } catch {
          name = encodedName || '查看文件';
        }
        return {
          url: valid ? content.contentFileUrl : '',
          name,
          text: content.contentFileText
        };
      } catch {
        return { url: '', name: '查看文件', text: content.contentFileText };
      }
    },
    addHandle(){
      setTimeout(()=> {
        this.addDialogShow = true;
      },200);

    },
    addSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      setTimeout(()=> {
        this.formData = row;
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      setTimeout(()=> {
        this.searchHandle();
      },200);
    },
    closeEditDialog(){
      this.formData = {};
      this.editDialogShow = false;
    },
    deleteHandle(id){
      this.$refs.muldelete.dialogShow = true;
      this.ids = id ? [id] : this.selected.map(item => item.id);
    },
    confirmDelete(ids){
      deleteArticle(ids).then((res) => {
        this.$refs.muldelete.loading = false;
        this.$refs.muldelete.dialogShow = false;
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      switch (tr.pushStatus) {
        case 0:
          return '未推送';
        case 1:
          return '已推送';
        case 2:
          return '已失效';
      }
    },
    getStyle(tr){
      if(tr.pushStatus === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else if(tr.pushStatus === 1){

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }else {
        return {
          backgroundColor: colorRgba('#F5F5F5',1),
          color: '#6B6C7B',
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .content-header {
    padding-top: 0;
  }
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
  //限制富文本图片大小
  .content {
    video {
      width: 480px;
      height: 270px;
      max-width: 100%;
      object-fit: contain;
      background: #000;
    }
    img {
      max-width: 200px!important;

    }
  }
}
</style>
<style lang="scss">
.strategy-manager {
  //限制富文本图片大小
  .content {

    img {
      max-height: 140px!important;
    }
  }
}
</style>
